import { ActionIcon, Button, Text } from "@mantine/core"
import { IconHome } from "@tabler/icons-react"

import { Tooltip } from "@/components/generic/Tooltip"
import { cn } from "@/lib/utils"
import Link from "next/link"

interface NavbarOptionButtonProps {
  isSelected: boolean
  isSidebarMenuExpanded: boolean
  label: string
  icon: typeof IconHome
  href: string
  testID?: string
}

export function NavbarOptionButton({
  isSelected,
  isSidebarMenuExpanded,
  label,
  icon: Icon,
  href,
  testID,
}: NavbarOptionButtonProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-center",
        isSidebarMenuExpanded ? "ml-2 w-full justify-start gap-2" : "center"
      )}
    >
      <Button
        component={Link}
        href={href}
        justify="flex-start"
        fullWidth
        variant={isSelected ? "white" : "transparent"}
        color={isSelected ? "blue" : "gray.3"}
        radius="md"
        className={cn(isSidebarMenuExpanded ? "" : "!hidden")}
        leftSection={
          <Icon style={{ width: "85%", height: "85%" }} stroke={1.5} />
        }
        data-testid={`${testID}-btn`}
      >
        <Text fw={isSelected ? 500 : 400}>{label}</Text>
      </Button>
      <Tooltip label={label} position="right">
        <ActionIcon
          component={Link}
          variant={isSelected ? "white" : "transparent"}
          color={isSelected ? "blue" : "gray.3"}
          size="lg"
          href={href}
          radius="md"
          aria-label={label}
          className={cn(
            "!min-h-[36px] !min-w-[36px]",
            isSidebarMenuExpanded ? "!hidden" : ""
          )}
          data-testid={`${testID}-btn`}
        >
          <Icon style={{ width: "60%", height: "60%" }} stroke={1.5} />
        </ActionIcon>
      </Tooltip>
    </div>
  )
}
